import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { checkErrorFileMaxSize, checkInputErrorFileMaxSize } from '@chilecompra/react-kit'
import { File, Toast, Typography, useFile, useViewport } from '@chilecompra/react-kit/components'
import { DOCUMENT_MIME_TYPES } from '../../config/settings/constants'
import { Grid } from './AttachFiles.styles'
import { GridContainer, GridItem } from '../../containers/QuoteBidSeller/QuoteBidSeller.styles'

/**
 * The AttachFiles's component.
 */
const AttachFiles = props => {
  const {
    error,
    info,
    label,
    leftBreakpoints,
    loading,
    margin,
    onUploadFile,
    paddingSubtitle,
    rightBreakpoints,
    sm,
    subtitle,
    infoAlert
  } = props
  const { size } = useViewport()
  const { authInfo } = useSelector(state => state.authorizationProvider)
  const {
    error: fileError,
    value: fileValue,
    onChange: handleFileChange
  } = useFile({
    errorCallbacks: [checkInputErrorFileMaxSize(20)],
    changeCallback: file => {
      if (checkErrorFileMaxSize(file, 20)) {
        onUploadFile(file)
      }
    }
  })

  return (
    <>
      <Grid container margin={margin}>
        <Grid sm={sm} item xs={12} {...leftBreakpoints}>
          <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body2">
            Adjuntar archivos
          </Typography>
          <Typography
            color="black1"
            fontSize="12px"
            lineHeight="14px"
            margin={size.isDownToTiny ? '0 0 4px' : '0 8px 0 0'}
            padding={paddingSubtitle}
            variant="body2"
          >
            {subtitle}
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {infoAlert && <GridContainer margin="0 0 16px">{infoAlert}</GridContainer>}
          <GridContainer>
            <GridItem xs={12} {...rightBreakpoints}>
              <File
                disabled={authInfo.hasObserverRole}
                accept={DOCUMENT_MIME_TYPES}
                error={fileError}
                info={info}
                label={label}
                loading={loading}
                value={fileValue}
                onChange={handleFileChange}
              />
            </GridItem>
            <GridItem sm xs={12} />
          </GridContainer>
        </Grid>
      </Grid>
      {error && (
        <Grid container>
          <Grid item xs={12}>
            <Toast severity="error">Error al subir el archivo</Toast>
          </Grid>
        </Grid>
      )}
    </>
  )
}

AttachFiles.defaultProps = {
  error: false,
  info: 'Tamaño máximo permitido: 20MB',
  label: 'documento anexo',
  leftBreakpoints: {},
  loading: false,
  margin: 0,
  paddingSubtitle: 0,
  rightBreakpoints: {},
  sm: 4,
  subtitle: 'Puedes subir archivos que especifiquen tu solicitud (opcional)',
  infoAlert: null
}

AttachFiles.propTypes = {
  error: PropTypes.bool,
  info: PropTypes.string,
  label: PropTypes.string,
  leftBreakpoints: PropTypes.shape({
    lg: PropTypes.number,
    md: PropTypes.number,
    sm: PropTypes.number,
    xs: PropTypes.number
  }),
  loading: PropTypes.bool,
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onUploadFile: PropTypes.func.isRequired,
  paddingSubtitle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rightBreakpoints: PropTypes.shape({
    lg: PropTypes.number,
    md: PropTypes.number,
    sm: PropTypes.number,
    xs: PropTypes.number
  }),
  sm: PropTypes.number,
  subtitle: PropTypes.node,
  infoAlert: PropTypes.node
}

export default AttachFiles
